import { createMutation } from '../api/mutation'

export const useCompleteOnboarding = createMutation({
    url: '/onboarding/complete',
    method: 'POST',
    keysToRefetch: [['onboarding-status']],
})

const useUpdateOnboarding = createMutation({
    url: '/onboarding',
    method: 'PATCH',
    keysToRefetch: [['onboarding-status']],
})
void useUpdateOnboarding
